import Navbar from "../../Components/NavBar/index";
import Footer from "../../Components/Footer/index";
import AuthorPageDetail from "../../Components/AuthorPageDetail/index";

/**
 * AuthorPage wrapper.
 * SEO is handled INSIDE AuthorPageDetail once the author data is loaded,
 * so we get the correct per-author canonical URL, title, and description.
 */
const AuthorPage = () => {
    return (
        <>
            <Navbar />
            <div >
                <AuthorPageDetail />
            </div>
            <Footer />
        </>
    );
};

export default AuthorPage;
